export default "__VITE_ASSET__CUQL6sut__"